import { NgModule, ModuleWithProviders } from '@angular/core';
import { ISkyResourceConfig } from './interface';
import { RESOURCE_CONFIG } from './const';

@NgModule()
export class SkyResourceModule {
  static forRoot(configFactory: () => ISkyResourceConfig): ModuleWithProviders<SkyResourceModule> {
    return {
      ngModule: SkyResourceModule,
      providers: [{ provide: RESOURCE_CONFIG, useFactory: configFactory }],
    };
  }
}
